module.exports = __webpack_public_path__ + "img/item_4.e20031a4.png";